import React from "react";

const missionGroups = [
  {
    title: "Mission ITM : mise en place et analyse d'écarts de prix",
    details: [
      "Rapprochement tarifs négociés, commandes, réceptions et factures.",
      "Détection des variations non justifiées, impacts inflation et erreurs de base tarifaire.",
      "Livrables prêts pour validation achats, finance et recouvrement fournisseur.",
    ],
  },
  {
    title: "Carrefour : contrôle fournisseur et pricing",
    details: [
      "Contrôle des conditions commerciales sur facture et hors facture.",
      "Analyse pricing, prix attendus, avoirs, marges perdues et litiges fournisseurs.",
      "Synthèses orientées direction financière et négociation fournisseur.",
    ],
  },
  {
    title: "Escompte, ristourne de bon paiement et règlement",
    details: [
      "Recalcul des escomptes contractuels à partir des conditions et du FEC.",
      "Identification des taux modaux, dates de paiement, factures éligibles et montants non récupérés.",
      "Analyse des doubles règlements, avoirs non rapprochés et paiements non imputés.",
    ],
  },
  {
    title: "Conditions tarifaires, FEC et baux commerciaux",
    details: [
      "Extraction des conditions tarifaires depuis PDF, Excel, emails et contrats.",
      "Contrôle FEC : comptes fournisseurs, lettrage, TVA, doublons, exhaustivité facture.",
      "Analyse de baux commerciaux : indexations, loyers, charges, taxes récupérables et clauses financières.",
    ],
  },
];

const pricingFactors = [
  "Taille de l'entreprise et nombre d'entités auditées",
  "Volume de fournisseurs, factures, lignes tarifaires et années analysées",
  "Qualité des données disponibles : FEC, ERP, commandes, réceptions, contrats, emails",
  "Complexité du recouvrement : validation interne, preuve fournisseur, circularisation, négociation",
];

const CommercialMissions = () => {
  return (
    <section className="commercial-missions-area pt-100 pb-100">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-9 text-center section-content">
            <span className="fs-15 fw-semibold sub-titles">Missions prêtes pour propositions commerciales</span>
            <h1 className="fs-50 mt-3 fw-bold">Des audits ciblés sur les revenus réellement récupérables</h1>
            <p className="fs-18">
              WBC transforme les dossiers fournisseurs complexes en propositions commerciales claires : périmètre, données nécessaires, méthode de calcul, potentiel de récupération, planning, preuves et livrables.
            </p>
          </div>
        </div>
        <div className="mission-grid pt-60">
          {missionGroups.map((mission) => (
            <article className="mission-card" key={mission.title}>
              <h2 className="fs-24 fw-bold">{mission.title}</h2>
              <ul>
                {mission.details.map((detail) => <li key={detail}>{detail}</li>)}
              </ul>
            </article>
          ))}
        </div>
        <div className="pricing-method mt-5">
          <div>
            <span className="fs-15 fw-semibold sub-titles">Méthode tarifaire</span>
            <h2 className="fs-40 fw-bold mt-3">Un prix dépendant du volume et du potentiel</h2>
            <p className="fs-18">
              Les honoraires sont adaptés à la taille de l'entreprise et au volume traité. La proposition distingue la phase de diagnostic, l'audit complet et, lorsque pertinent, une part indexée sur les montants recouvrés.
            </p>
            <p className="fs-18">
              Selon la qualité du dossier et le périmètre retenu, une partie significative des revenus identifiés peut être récupérée : l'objectif est de sécuriser un modèle où 30 à 40% du potentiel détecté devient effectivement recouvrable après validation et négociation.
            </p>
          </div>
          <ul>
            {pricingFactors.map((factor) => <li key={factor}>{factor}</li>)}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default CommercialMissions;
